<script>
import { Line } from 'vue-chartjs';

export default {
  name: 'JobStatsChart',
  extends: Line,
  props: {
    runs: {
      type: Array,
      required: true,
    },
  },
  watch: {
    runs() {
      this.draw();
    },
  },
  methods: {
    draw() {
      // Defer to the next tick so this never runs inside the parent's patch
      // (a synchronous throw here would otherwise leave the loading spinner
      // stuck in the DOM until the modal is closed and reopened).
      this.$nextTick(() => {
        try {
          this.renderChart(this.chartData, this.chartOptions);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('JobStatsChart render failed', e);
        }
      });
    },
  },
  computed: {
    chartData() {
      const labels = this.runs.map(run => {
        const d = run.finished_at ? new Date(run.finished_at) : null;
        if (!d) return '—';
        return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
      });

      return {
        labels,
        datasets: [
          {
            label: 'Pages crawled',
            borderColor: '#0d6efd',
            backgroundColor: 'rgba(13,110,253,0.1)',
            data: this.runs.map(run => run.pages_crawled),
            fill: false,
            tension: 0.2,
            pointRadius: 3,
          },
          {
            label: 'Items extracted',
            borderColor: '#20c997',
            backgroundColor: 'rgba(32,201,151,0.1)',
            data: this.runs.map(run => run.items_extracted),
            fill: false,
            tension: 0.2,
            pointRadius: 3,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 0 },
        legend: { position: 'bottom' },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            title: (tooltipItems) => {
              const run = this.runs[tooltipItems[0].index];
              const d = run.finished_at ? new Date(run.finished_at) : null;
              return d ? d.toLocaleString() : '—';
            },
          },
        },
        scales: {
          xAxes: [{
            ticks: {
              maxRotation: 0,
              autoSkip: true,
              maxTicksLimit: 6,
            },
          }],
          yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
        },
      };
    },
  },
  mounted() {
    this.draw();
  },
};
</script>
